/** Canonical snake_case merge-tag keys used in leads templates and designer email. */
export const LEAD_MERGE_TAG_KEYS = {
  LEAD_FULL_NAME: "lead_fullname",
  LEAD_FIRST_NAME: "lead_first_name",
  LEAD_LAST_NAME: "lead_last_name",
  LEAD_BIRTHDATE: "lead_birthdate",
  LEAD_EMAIL: "lead_email",
  LEAD_PHONE: "lead_phone",
  LEAD_ZIP_CODE: "lead_zip_code",
  LEAD_SERVICE_INTERESTS: "lead_service_interests",
  PAGE_URL: "page_url",
  FORM_TITLE: "form_title"
} as const;

/** Legacy PascalCase keys kept for backward compatibility with existing templates. */
export const LEGACY_LEAD_CONTACT_OPTIONS = {
  LEAD_FIRST_NAME: "Lead.FirstName",
  LEAD_LAST_NAME: "Lead.LastName",
  LEAD_FULL_NAME: "Lead.FullName",
  LEAD_PHONE: "Lead.Phone",
  LEAD_EMAIL: "Lead.Email",
  LEAD_SERVICE_INTERESTS: "Lead.ServiceInterests",
  LEAD_PREFERRED_CHANNEL: "Lead.PreferredChannel",
  LEAD_LOCATION_NAME: "Lead.ClinicName",
  LEAD_LOCATION_PHONE: "Lead.ClinicPhone"
} as const;

export const LEAD_CONTACT_OPTIONS = LEAD_MERGE_TAG_KEYS;

export const LEAD_CONTACT_MENU_OPTIONS = {
  title: "Lead",
  menu: [
    {
      title: "Full Name",
      value: LEAD_MERGE_TAG_KEYS.LEAD_FULL_NAME
    },
    {
      title: "First Name",
      value: LEAD_MERGE_TAG_KEYS.LEAD_FIRST_NAME
    },
    {
      title: "Last Name",
      value: LEAD_MERGE_TAG_KEYS.LEAD_LAST_NAME
    },
    {
      title: "Birth Date",
      value: LEAD_MERGE_TAG_KEYS.LEAD_BIRTHDATE
    },
    {
      title: "Email",
      value: LEAD_MERGE_TAG_KEYS.LEAD_EMAIL
    },
    {
      title: "Phone",
      value: LEAD_MERGE_TAG_KEYS.LEAD_PHONE
    },
    {
      title: "Zip Code",
      value: LEAD_MERGE_TAG_KEYS.LEAD_ZIP_CODE
    },
    {
      title: "Service Interests",
      value: LEAD_MERGE_TAG_KEYS.LEAD_SERVICE_INTERESTS
    },
    {
      title: "Page Url",
      value: LEAD_MERGE_TAG_KEYS.PAGE_URL
    },
    {
      title: "Form Title",
      value: LEAD_MERGE_TAG_KEYS.FORM_TITLE
    }
  ]
};

const LEAD_MERGE_TAG_BODY_PATTERN = Object.values(LEAD_MERGE_TAG_KEYS).join("|");
const LEGACY_LEAD_MERGE_TAG_BODY_PATTERN = Object.values(
  LEGACY_LEAD_CONTACT_OPTIONS
)
  .map((value) => value.replace(/\./g, "\\."))
  .join("|");

/** Matches `{{lead_first_name}}` style tokens (with or without surrounding braces in the body). */
export const LEAD_MERGE_TAG_TOKEN_REGEXP = new RegExp(
  `^(?:${LEAD_MERGE_TAG_BODY_PATTERN})$`
);

export const isLeadMergeTagToken = (tagName: string): boolean => {
  const body = tagName.replace(/^\{\{/, "").replace(/\}\}$/, "");
  return (
    LEAD_MERGE_TAG_TOKEN_REGEXP.test(body) ||
    new RegExp(`^(?:${LEGACY_LEAD_MERGE_TAG_BODY_PATTERN})$`).test(body)
  );
};
